import { t } from '@lingui/macro';

export const CONFIGS = {
    GRID: {
        color: ['#F7D63F', '#6596FF', '#3DD781'],
        DATE_FILED: ['gridPwr', 'soc'],
        OTHER_FILED: ['From Solar', 'To Home', 'To Battery'],
        NEGATIVE_INDEX: ['From Solar'],
    },
    GRID_DC303: {
        color: ['#40DEEF', '#FAB333'],
        DATE_FILED: ['sysGridPwr', 'soc'],
        OTHER_FILED: ['fromGrid', 'toGrid'],
        NEGATIVE_INDEX: ['toGrid'],
    },
    BATTERY: {
        color: ['#F7D63F', '#59DFED', '#6596FF'],
        DATE_FILED: ['bpPwr', 'soc'],
        OTHER_FILED: ['From Solar', 'From Grid', 'To Home'],
        NEGATIVE_INDEX: ['From Solar', 'From Grid'],
    },
    BATTERY_DC303: {
        color: ['#3DD781', '#FAB333'],
        DATE_FILED: ['bpPwr', 'soc'],
        OTHER_FILED: ['toBattery', 'fromBattery'],
        NEGATIVE_INDEX: ['fromBattery'],
    },
    SOLAR: {
        color: ['#6596FF', '#3DD781', '#59DFED'],
        DATE_FILED: ['mpptPwr', 'soc'],
        OTHER_FILED: ['To Home', 'To Battery', 'To Grid'],
    },
    SOLAR_DC303: {
        color: ['#6596FF', '#3DD781', '#59DFED'],
        DATE_FILED: ['solarPwr', 'soc'],
        OTHER_FILED: ['To Home', 'To Battery', 'To Grid'],
    },
    HOME: {
        color: ['#F7D63F', '#3DD781', '#59DFED'],
        DATE_FILED: ['loadPwr', 'soc'],
        OTHER_FILED: ['From Solar', 'From Battery', 'From Grid'],
    },
    OVERVIEW: {
        color: ['#F7D63F', '#59DFED', '#3DD781', '#6596FF'],
        DATE_FILED: ['mpptPwr', 'loadPwr', 'bpPwr', 'gridPwr', 'soc'],
        OTHER_FILED: ['From Solar', 'From Grid', 'From Battery', 'To Grid', 'To Battery', 'To Home', 'Self-sufficiency'],
        NEGATIVE_INDEX: ['To Grid', 'To Battery', 'To Home'],
    },
    OVERVIEW_DC303: {
        color: ['#F7D63F', '#59DFED', '#3DD781', '#6596FF'],
        DATE_FILED: ['solarPwr', 'loadPwr', 'bpPwr', 'gridPwr', 'soc'],
        OTHER_FILED: ['From Solar', 'From Grid', 'From Battery', 'To Grid', 'To Battery', 'To Home'],
        NEGATIVE_INDEX: ['To Grid', 'To Battery', 'To Home'],
    },
    EERNINGS: {
        color: ['#F7D63F', '#59DFED'],
        DATE_FILED: ['Solar Saving', 'Feed In'],
        OTHER_FILED: ['Solar Saving', 'Feed In'],
    },
    HOMEPD303: {
        color: ['#DA84F5', '#3DD781', '#59DFED'],
        DATE_FILED: ['Home'],
        OTHER_FILED: ['Generator', 'Grid', 'From Battery'],
    },
    GRIDPD303: {
        color: ['#40DEEF'],
        DATE_FILED: ['Grid'],
        OTHER_FILED: ['Grid'],
        NEGATIVE_INDEX: [],
    },
    BATTERYPD303: {
        color: ['#FAB333', '#3DD781'],
        DATE_FILED: ['Battery'],
        OTHER_FILED: ['Discharging', 'Charging'],
        NEGATIVE_INDEX: ['Discharging'],
    },
    GENERATOR: {
        color: ['#DA84F5'],
        DATE_FILED: ['Generator'],
        OTHER_FILED: ['Generator'],
        NEGATIVE_INDEX: [],
    },
};

export type ChartItem = {
    indexName: string; // 指标名
    unit: string; // 单位
    datas: Array<{
        desc?: any;
        extra?: any;
        xdata: string;
        ydata: number;
    }>;
};

// 设备类型
export const CATEGORY = [
    { value: 'Overview', label: t({ message: 'Overview' }) },
    { value: 'Solar', label: t({ message: 'Solar' }) },
    { value: 'Home', label: t({ message: 'Home', id: 'Home.dashboard' }) },
    { value: 'Battery', label: t({ message: 'Battery' }) },
    { value: 'Grid', label: t({ message: 'Grid' }) },
    { value: 'Earnings', label: t({ message: 'Earnings' }) },
] as const;
export type CategorType = (typeof CATEGORY)[number]['value'];

// 日期选项
export const getDateOptions = () => [
    { key: 'date', label: t`Day` },
    { key: 'week', label: t({ message: 'Week' }) },
    { key: 'month', label: t({ message: 'Month' }) },
    { key: 'year', label: t({ message: 'Year' }) },
    { key: 'total', label: t({ message: 'Total' }) },
];

// 入参映射
export const Params_add = {
    date: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    total: 'Total',
};

export type DateType = 'date' | 'week' | 'month' | 'year' | 'total';

export type ExDateType = Exclude<DateType, 'total'>;

// 后端映射类型
export const TIMETYPE_MAP = {
    date: 0,
    week: 1,
    month: 2,
    year: 3,
    total: 4,
};

// 后端映射类型
export const QUERYTYPE_MAP = {
    Overview: 0,
    Solar: 1,
    Grid: 2,
    Battery: 3,
    Home: 4,
};

// 后端指标映射字段
export const INDEX_TYPE = [
    'Self-sufficiency', //自给自足
    'Solar Value', // 能源价值
    'From Solar', // 来自太阳能
    'From Battery', // 来自电池
    'From Grid', // 来自市电
    'To Home', //流向家庭
    'To Battery', //流向电池
    'To Grid', // 流向电网
    'Total', // 市电合计
    'Total Charge', // 总充电
    'Total Discharge', //总放电
    'Total Generation', //总生产能量
    'Total Consumption', //总消耗
    'Import', //总输入
    'Export', //总输出
    'Energy Value',
    'Solar Saving',
    'Feed In',
    'totalHome',
    'pv_to_powerplus', // 流向充电桩
    'pv_to_powerplus_pct', // 充电桩比例
    'Charging',
    'Discharging',
    'Form Grid',
    'Form Battery',
    'Form Generator',
    'Form Battery pct',
    'Form Grid pct',
    'Form Generator pct',
    'Total Grid',
    'Total Generator',
    'Solar Generation', // 太阳能总生产
    'Home Load', // 家庭负荷
    'pv_to_heatpump', // 热泵
] as const;

// 总览指标
export type IndexType = (typeof INDEX_TYPE)[number];

// 总览指标数据结构
export type IndexProps = {
    [key in IndexType]: {
        indexName: string;
        value: number | null;
        unit: string | null;
    };
};

// 生成默认数据
export const DEFAULT_DATA = () => {
    return INDEX_TYPE.reduce((total, item) => {
        total[item] = { indexName: '', value: null, unit: null };
        return total;
    }, {} as IndexProps);
};

// 图表格式化数据源类型
export type ChartSourceType = {
    [key: string]: {
        unit: string;
        datas: {
            [key: string]: number;
        };
    };
};

// 图表数据结构
export type DatasetType = {
    dimensions: string[];
    source: (string | number)[][];
    maxValue: number;
    units: string[];
};
export interface ChartDataType {
    dateType: DateType;
    dataset: DatasetType;
}
export interface ChartDataEntryType extends Omit<ChartDataType, 'dataset'> {
    dataset: DatasetType | null;
}

export const getWeekName = () => {
    return {
        0: t`Sun`,
        1: t`Mon`,
        2: t`Tue`,
        3: t`Wed`,
        4: t`Thur`,
        5: t`Fri`,
        6: t`Sat`,
    };
};

export const getIndexMap = () => {
    return {
        solarPwr: t`Solar`,
        mpptPwr: t`Solar`,
        loadPwr: t({ id: 'Home.dashboard', message: 'Home' }),
        bpPwr: t`Battery`,
        gridPwr: t`Grid`,
        sysGridPwr: t`Grid`,
        toGrid: t`Export`,
        fromGrid: t`Import`,
        'Self-sufficiency': t`Self-sufficiency`,
        'Solar Value': t`Solar Value`,
        'From Solar': t`From Solar`,
        'From Battery': t`From Battery`,
        'From Grid': t`From Grid`,
        'To Home': t`To Home`,
        Home: t`To Home`,
        Grid: t`From Grid`,
        Battery: t`Battery`,
        totalHome: t`To Home`,
        'To Battery': t`To Battery`,
        toBattery: t`Charge`,
        fromBattery: t`Discharge`,
        'To Grid': t`To Grid`,
        'Total Charge': t`Total Charge`,
        'Total Discharge': t`Total Discharge`,
        'Total Generation': t`Total Generation`,
        'Total Consumption': t`Total Consumption`,
        soc: t`soc`,
        'Solar Saving': t`Solar Saving`,
        'Feed In': t`Feed In`,
        Charging: t`Charge`,
        Discharging: t`Discharge`,
        Generator: t`From Generator`,
    };
};

export const getIndexOverviewMap = () => {
    return {
        'Self-sufficiency': t`Self-sufficiency`,
        'From Solar': t`Solar`,
        'From Battery': t`Battery`,
        'From Grid': t`Grid`,
        'To Home': t({ id: 'Home.dashboard', message: 'Home' }),
        'To Battery': t`Battery`,
        'To Grid': t`Grid`,
        'Solar Saving': t`Solar Saving`,
        'Feed In': t`Feed In`,
    };
};

// 图表数据源
export interface ChartApiSource {
    dateType: DateType;
    datas: ChartItem[];
    xdata: string[];
}
